/** Safe wrappers around browser storage APIs. Never throw (handles SSR + privacy mode). */

export function getLocalStorage(key: string): string | null {
  try {
    return typeof localStorage !== 'undefined'
      ? localStorage.getItem(key)
      : null
  } catch {
    return null
  }
}

export function setLocalStorage(key: string, value: string): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(key, value)
  } catch {
    // storage blocked (privacy mode / SSR)
  }
}

export function removeLocalStorage(key: string): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.removeItem(key)
  } catch {
    // storage blocked (privacy mode / SSR)
  }
}

export function getSessionStorage(key: string): string | null {
  try {
    return typeof sessionStorage !== 'undefined'
      ? sessionStorage.getItem(key)
      : null
  } catch {
    return null
  }
}

export function setSessionStorage(key: string, value: string): void {
  try {
    if (typeof sessionStorage !== 'undefined')
      sessionStorage.setItem(key, value)
  } catch {
    // storage blocked
  }
}

export function removeSessionStorage(key: string): void {
  try {
    if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key)
  } catch {
    // storage blocked
  }
}
